<template>
  <div class="select-list-wrapper">
    <CommonInput
      v-model="currentValue"
      theme="white"
      type="text"
      :placeholder="placeholder"
      readonly
      :on-focus="showPopup"
    >
      <img
        class="select_account_arrow_img"
        :class="[$store.state.isMirroring && 'mirror']"
        src="@/assets/back_new.png"
        alt=""
      />
    </CommonInput>
    <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '40%', overflow: 'hidden' }"
      :safe-area-inset-bottom="true"
    >
      <div class="select_list_popup">
        <van-picker
          :title="placeholder"
          show-toolbar
          :columns="columns"
          :confirm-button-text="$t('common.confirm')"
          :cancel-button-text="$t('common.cancel')"
          @confirm="onConfirm"
          @cancel="closePopup"
          @change="onChange"
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { Picker } from 'vant'
import CommonInput from '@/components/CommonInput'

Vue.use(Picker)

export default {
  name: 'SelectList',
  data() {
    return {
      show: false,
      currentValue: this.value
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: String,
    maxlength: Number,
    placeholder: String,
    columns: Array
  },
  components: { CommonInput },
  methods: {
    showPopup() {
      this.show = true
    },
    closePopup() {
      this.show = false
    },
    onConfirm(value) {
      this.show = false
      this.currentValue = value.text
      this.$emit('change', value.value)
    },
    onChange(picker, value) {
      this.$emit('change', value.value)
    }
  }
}
</script>

<style scoped>
.select-list-wrapper {
  width: 100%;
}

.select_account_arrow {
  flex: none;
  box-sizing: border-box;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.select_account_arrow_img {
  width: 0.12rem;
  height: 0.12rem;
  transform: rotateY(180deg);
}

.select_account_arrow_img.mirror {
  transform: none;
}

.select_list_popup {
  width: 100%;
  height: 100%;
  background: #fff;
}

.arrow {
  width: 0.1rem;
  height: 0.1rem;
  transform: rotate(180deg);
}

.arrow.mirror {
  transform: rotate(0deg);
}
</style>

<style>
.select-list-wrapper .van-picker__cancel,
.select-list-wrapper .van-picker__confirm {
  font-weight: 500;
}

.select-list-wrapper .van-cell {
  cursor: unset;
  background-color: unset;
  width: 100%;
  height: 0.36rem;
  padding: 0;
  text-align: center;
  font-size: 0.14rem;
  margin: 0;
}

.select-list-wrapper .van-field__body {
  height: 100%;
}

.select-list-wrapper .van-field__control {
  text-align: center;
  margin: auto 0;
  color: #2c3e50;
}

.select-list-wrapper .van-field__control::-webkit-input-placeholder {
  color: #7c7c7c;
  font-size: 0.14rem;
}

.select-list-wrapper .van-cell::after {
  content: none;
}

.select-list-wrapper .van-cell--clickable:active {
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/components/SelectList.vue